// extracted by mini-css-extract-plugin
module.exports = {"searchForm":"searchForm-QESAH","passengerAge":"passengerAge-1uFWt","placeholder":"placeholder-3gCoX","passengers__itemFNN":"passengers__itemFNN-Hn10y"};